import { default as WebModal } from 'modal-react-native-web'
import { Platform, Modal as RNModal, SafeAreaView, View } from 'react-native'
import { ColorOptions } from '../../theme/UiThemeProvider'
import { convertHexToRGBA } from '../../utils/utils'
import { Box } from '../Box'
import { Icon } from '../Icon'
import { Text } from '../Text'
import styles from './styles'
import { ModalDialogProps, ModalHeaderTypes, ModalTypes } from './types'

const ModalDialog = ({
  type = 'Centered',
  show = false,
  children,
  onDismiss,
  title,
  containerTopPadding,
  isFromDropDown = false,
  isFullWidth = false,
  theme,
  testID,
  fontFamily,
  isExtraWidth = false,
  paddingHorizontal,
  underlayBackground,
}: ModalDialogProps) => {
  if (!show) {
    return null
  }
  const Modal = Platform.OS === 'web' ? WebModal : RNModal
  if (Platform.OS === 'web') {
    Modal.setAppElement(document.querySelector('#root'))
    Modal.setAppElement('body')
  }

  const modalStyle = styles(theme)
  const container = modalStyle[type].contentContainer(isFullWidth)
  const innerContainer = modalStyle[type].innerContainer(isFromDropDown, isFullWidth, isExtraWidth)
  const background = modalStyle[type].background
  if (containerTopPadding) {
    container.paddingTop = containerTopPadding
  }

  const childComp = (
    <>
      <View style={{ ...container, paddingHorizontal: paddingHorizontal }} pointerEvents={'box-none'}>
        <SafeAreaView style={innerContainer}>
          {!!title && (
            <ModalHeader
              fontFamily={fontFamily}
              title={title}
              onDismiss={onDismiss}
              center={type === 'Centered'}
              theme={theme}
            />
          )}
          {children}
        </SafeAreaView>
      </View>
      <Box
        {...background}
        testID={'toast-close'}
        onPress={onDismiss}
        {...(underlayBackground && { backgroundColor: underlayBackground })}
        underlayColor={type !== 'Toast' ? modalStyle.underlayColor : 'TRANSPARENT'}>
        <View />
      </Box>
    </>
  )

  return (
    <Modal testID={testID} animationType="fade" ariaHideApp={false} transparent visible={show} onDismiss={onDismiss}>
      {childComp}
    </Modal>
  )
}

const ModalHeader = ({
  title = '',
  onDismiss = () => { },
  center = false,
  theme,
  type = 'Default',
  fontFamily,
}: any) => {
  const modalHeaderStyle = styles(theme)
  const titleStyle = modalHeaderStyle[type].headerTitle
  const headerStyle = modalHeaderStyle[type].containerHeader
  return (
    <Box {...headerStyle}>
      <Text fontFamily={fontFamily} {...titleStyle}>
        {title}
      </Text>
      {!center && (
        <Box
          onPress={onDismiss}
          underlayColor={theme ? (theme?.headingText as ColorOptions) : 'GREY_1_SEPARATOR'}
          {...modalHeaderStyle.containerButton}>
          <Icon
            id={'CLOSE'}
            size={16}
            color={theme ? (convertHexToRGBA(theme?.headingText, 50) as ColorOptions) : undefined}
          />
        </Box>
      )}
    </Box>
  )
}

export { ModalTypes, ModalHeaderTypes }
export { ModalDialog }

